import React from 'react';
import { Button } from 'primereact/button';

const EmployeeDetails = ({
  detailsEmployee,
  handleBackToTable
}) => {
  return (
    <div className="bg-white/90 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/20 flex gap-8 relative overflow-hidden mt-2">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

      <div className="absolute top-4 left-4 z-20">
        <button onClick={handleBackToTable} className="px-3 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
          <i className="pi pi-arrow-left text-xs"></i> Back
        </button>
      </div>

    {/* Right side - Photo */}
      <div className="w-1/3 flex flex-col items-center justify-start z-10 pt-10">
        <div className="w-80 h-96 rounded-2xl overflow-hidden shadow-2xl border-4 border-white flex items-center justify-center bg-gray-100 relative group">
          {detailsEmployee.photoUrl ? (
            <img src={detailsEmployee.photoUrl} alt="Employee" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
          ) : (
            <div className="text-8xl font-bold bg-gradient-to-br from-indigo-500 to-purple-600 bg-clip-text text-transparent">
              {((detailsEmployee.firstName || '')[0] || '') + ((detailsEmployee.lastName || '')[0] || '')}
            </div>
          )}
          <div className="absolute bottom-6 right-6 w-10 h-10 bg-green-500 rounded-full border-4 border-white flex items-center justify-center shadow-lg">
            <i className="pi pi-check text-white text-sm"></i>
          </div>
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>

      </div>
      {/* Left side - Details */}
      <div className="flex-1 z-10 space-y-6">
        <div className="flex items-center justify-between mb-2">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {(detailsEmployee.firstName || '') + ' ' + (detailsEmployee.lastName || '')}
            </h3>
          </div>

          <div className="flex items-center gap-4">
            <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
              <i className="pi pi-id-card mr-2"></i>
              EMP0{detailsEmployee.id || '-'}
            </span>

            <span
              className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${detailsEmployee.status === 'active'
                ? 'bg-green-100 text-green-800'
                : detailsEmployee.status === 'inactive'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-yellow-100 text-yellow-800'
                }`}
            >
              <i className="pi pi-circle-fill mr-2 text-xs"></i>
              {detailsEmployee.status
                ? detailsEmployee.status.charAt(0).toUpperCase() + detailsEmployee.status.slice(1)
                : 'Active'}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
            <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
              <i className="pi pi-envelope mr-2"></i>Contact Information
            </h4>
            <div className="space-y-2">
              <p className="text-sm"><span className="font-medium">Email:</span> {detailsEmployee.email}</p>
              <p className="text-sm"><span className="font-medium">Phone:</span> {detailsEmployee.phone}</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-xl border border-green-100">
            <h4 className="text-sm font-semibold text-green-800 mb-3 flex items-center">
              <i className="pi pi-user mr-2"></i>Personal Details
            </h4>
            <div className="space-y-2">
              <p className="text-sm"><span className="font-medium">DOB:</span> {detailsEmployee.dateOfBirth ? new Date(detailsEmployee.dateOfBirth).toLocaleDateString() : '-'}</p>
              <p className="text-sm"><span className="font-medium">Gender:</span> {detailsEmployee.gender ? detailsEmployee.gender.charAt(0).toUpperCase() + detailsEmployee.gender.slice(1) : '-'}</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-red-50 p-4 rounded-xl border border-orange-100">
            <h4 className="text-sm font-semibold text-orange-800 mb-3 flex items-center">
              <i className="pi pi-briefcase mr-2"></i>Employment
            </h4>
            <div className="space-y-2">
              <p className="text-sm"><span className="font-medium">Joined:</span> {detailsEmployee.joiningDate ? new Date(detailsEmployee.joiningDate).toLocaleDateString() : '-'}</p>
              <p className="text-sm"><span className="font-medium">Salary:</span> ₹{detailsEmployee.salary ? Number(detailsEmployee.salary).toLocaleString() : '-'}</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-4 rounded-xl border border-purple-100 lg:col-span-2">
            <h4 className="text-sm font-semibold text-purple-800 mb-3 flex items-center">
              <i className="pi pi-building mr-2"></i>Department & Role
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-purple-600 font-medium uppercase tracking-wider">Department</p>
                <p className="text-sm font-bold text-gray-900">{detailsEmployee.departmentName || '-'}</p>
              </div>
              <div>
                <p className="text-xs text-purple-600 font-medium uppercase tracking-wider">Designation</p>
                <p className="text-sm font-bold text-gray-900">{detailsEmployee.designation || '-'}</p>
              </div>
              <div className="col-span-2">
                <p className="text-xs text-purple-600 font-medium uppercase tracking-wider">Supervisor</p>
                <p className="text-sm font-bold text-gray-900">
                  {detailsEmployee.supervisorFirstName ? `${detailsEmployee.supervisorFirstName} ${detailsEmployee.supervisorLastName}` : 'No supervisor assigned'}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-cyan-50 to-teal-50 p-4 rounded-xl border border-cyan-100">
            <h4 className="text-sm font-semibold text-cyan-800 mb-3 flex items-center">
              <i className="pi pi-map-marker mr-2"></i>Address
            </h4>
            <p className="text-sm text-gray-700 leading-relaxed">
              {detailsEmployee.address || 'No address provided'}
            </p>
          </div>
        </div>
      </div>

  
    </div>
  );
};

export default EmployeeDetails;
